import _reject from 'lodash/reject';
import _findIndex from 'lodash/findIndex';
import axios from 'axios';
import Vue from 'vue';
import { auth } from '../utils/requests';
import {
    TAGS_LIST, TAGS_DETAIL, NOTE_TAGS_LIST, NOTE_TAGS_DETAIL,
} from '../api';
import { request_mutations, request_state } from '../utils/store';

export default {
    namespaced: true,
    state: {
        filter_tags: [],
        list: request_state(),
        create: request_state(),
        remove: request_state(),
        update: request_state(),
        create_note_tag: request_state(),
        remove_note_tag: request_state(),
    },
    mutations: {
        ...request_mutations('list', 'list'),
        ...request_mutations('create', 'create'),
        ...request_mutations('remove', 'remove'),
        ...request_mutations('update', 'update'),
        ...request_mutations('create_note_tag', 'create_note_tag'),
        ...request_mutations('remove_note_tag', 'remove_note_tag'),
        remove_filter_tag(state, id) {
            state.filter_tags = _reject(state.filter_tags, { id });
        },
        add_filter_tags(state, tags) {
            state.filter_tags = [...state.filter_tags, ...tags];
        },
        clean_filter_tags(state) {
            state.filter_tags = [];
        },
        remove_tag(state, id) {
            state.list.data.results = _reject(state.list.data.results, { id });
        },
        extend_list(state, data) {
            state.list.loading = false;
            state.list.error = {};
            state.list.data.results.push(...data.results);
            state.list.data.next = data.next;
        },
        change_tag(state, { id, tag }) {
            const index = _findIndex(state.list.data.results, { id });
            Vue.set(state.list.data.results, index, tag);
        },
        add_tag(state, tag) {
            state.list.data.results = [tag, ...state.list.data.results];
        },
    },
    actions: {
        list({ commit }, {
            space_id, search, page, extend, ids = [], exclude_ids = [],
        }) {
            const url = TAGS_LIST.replace('{space_id}', space_id);
            commit('list_loading');
            return new Promise((resolve) => {
                axios.get(url, {
                    params: {
                        search, ids, exclude_ids, page,
                    },
                    ...auth(),
                }).then((response) => {
                    commit(extend ? 'extend_list' : 'list_success', response.data);
                    resolve(response.data);
                }).catch(error => commit('list_error', error.response ? error.response.data : {}));
            });
        },
        create({ commit }, { space_id, data }) {
            const url = TAGS_LIST.replace('{space_id}', space_id);

            commit('create_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('create_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, { space_id, tag_id }) {
            const url = TAGS_DETAIL.replace('{space_id}', space_id).replace('{tag_id}', tag_id);

            commit('remove_loading');
            axios.delete(url, auth()).then((response) => {
                commit('remove_success', response.data);
                commit('remove_tag', tag_id);
            }).catch(error => commit('remove_error', error.response ? error.response.data : {}));
        },
        update({ commit }, { space_id, tag_id, data }) {
            const url = TAGS_DETAIL.replace('{space_id}', space_id).replace('{tag_id}', tag_id);

            commit('update_loading');
            return new Promise((resolve) => {
                axios.put(url, data, auth()).then((response) => {
                    commit('update_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('update_error', error.response ? error.response.data : {});
                });
            });
        },
        create_note_tag({ commit }, { space_id, note_id, name }) {
            const url = NOTE_TAGS_LIST
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id);

            commit('create_note_tag_loading');
            return new Promise((resolve) => {
                axios.post(url, { name }, auth()).then((response) => {
                    commit('create_note_tag_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('create_note_tag_error', error.response ? error.response.data : {});
                });
            });
        },
        remove_note_tag({ commit }, { space_id, note_id, tag_id }) {
            const url = NOTE_TAGS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{tag_id}', tag_id);

            commit('remove_note_tag_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_note_tag_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('remove_note_tag_error', error.response ? error.response.data : {});
                });
            });
        },
    },
};
